import { render, staticRenderFns } from "./relatedProducts.vue?vue&type=template&id=ba797e40&scoped=true"
import script from "./relatedProducts.vue?vue&type=script&lang=js"
export * from "./relatedProducts.vue?vue&type=script&lang=js"
import style0 from "./relatedProducts.vue?vue&type=style&index=0&id=ba797e40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba797e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba797e40')) {
      api.createRecord('ba797e40', component.options)
    } else {
      api.reload('ba797e40', component.options)
    }
    module.hot.accept("./relatedProducts.vue?vue&type=template&id=ba797e40&scoped=true", function () {
      api.rerender('ba797e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/relatedProducts.vue"
export default component.exports